






import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import store from '@/store/store';
import Auth from '@/store/modules/auth';
import { log } from '@/plugins/logger';
const authModule = getModule(Auth, store);

@Component
export default class LikeButton extends Vue {
  @Prop(Number) fontSize: number;
  @Prop(Object) likers: { [uid: string]: boolean };

  get style() {
    return `font-size: ${this.fontSize || 30} px;`;
  }

  get user() {
    return authModule.user;
  }

  get likedByMe(): boolean {
    if (!this.user) return false;
    return this.likers[this.user.uid];
  }

  toggleLike() {
    if (!this.user) return;
    this.$emit('toggle', this.user.uid, !this.likers[this.user.uid]);
    //console.log(this.likers);
    log('LIKE_TOGGLE', { from: this.user.uid });
  }
}
